const feedbacks = [
    {
        id: 1,
        text: 'Managing employee records, payroll and leave requests used to be a nightmare. With HRMS Portal, everything is streamlined, saving us countless hours every month!',
        name: '— Priya S., HR Manager',
    },
    {
        id: 2,
        text: 'Payroll processing is now effortless and tracking employee attendance has never been more accurate. The automation features have drastically improved our efficiency!',
        name: '— Amit K., Finance Lead',
    },
    {
        id: 3,
        text: 'From job postings to candidate onboarding, this platform handles it all. Our hiring process is now faster and more organized than ever before!',
        name: '— Neha R., Talent Acquisition Specialist',
    },
]

const HRManagementInAction = () => {
    return (
        <section className='bg-[#FFEAEA] py-32 px-2 sm:px-10 md:gap-8'>
            <h3 className='text-center text-4xl font-bold md:text-5xl'>
                See HR Management in <span className='text-[#FF3B38]'>Action!</span>
            </h3>
            <p className='mt-4 text-center text-base font-semibold text-[#646569] md:text-xl'>
                Hear what our clients have to say about their experience with HRMSPortals.
            </p>
            <div className='mt-8 flex flex-col gap-8 lg:flex-row'>
                {feedbacks.map((feedback) => (
                    <div
                        key={feedback.id}
                        className='flex flex-1 flex-col justify-between border border-[#CCCCCC] bg-white p-5'>
                        <p className='text-lg font-semibold text-[#6F6F6F]'>"{feedback.text}"</p>
                        <p className='mt-12 font-bold text-[#2A2A2A]'>{feedback.name}</p>
                    </div>
                ))}
            </div>
        </section>
    )
}

export default HRManagementInAction
